<template>
  <div class="mb-4">
    <h5 class="mb-2">
      {{
        "bank_request_sent"
          | setText(
            'Запрос отправлен. Ожидайте ответ. Чтобы проверить статус нажмите "Проверить"'
          )
      }}
    </h5>
    <button class="btn btn-info btn-info mr-2" @click="sendRequest">
      {{ "check_status" | setText("Проверить статус") }}
    </button>
    <button class="btn btn-info btn-danger" @click="cancelRequest">
      {{ "to_cancel" | setText("Отменить") }}
    </button>
  </div>
</template>
<script>
import { logger, errorNotify, toFormData } from "@/plugins/functions";

export default {
  methods: {
    async sendRequest() {
      this.$loading(true);

      const action = `applications/${this.data.exchange_id}/status`;
      const url = this.data.bank.api_endpoint_url + action;
      const token = this.data.bank.api_token;
      const auth_type = this.data.bank.api_auth_type;
      const method = "get";
      // const data = this.data.form_data;

      logger(this.$http, {
        name: "Проверить запрос в банк",
        url: url,
        method: method,
        // req: JSON.stringify(data),
      });

      return this.$http({
        method: method,
        // data: toFormData(data),
        url: url,
        headers: {
          // "Content-Type": `multipart/form-data`,
          Authorization: `${auth_type} ${token}`,
          "api-version": `1`,
          platform: `web`,
          language: `ru`,
          Accept: `application/json`,
        },
      })
        .then((response) => {
          const data = response.data;
          if (data && data.data && data.success === true) {
            let state = "sent";

            if (
              data.data.status === "pre_scoring_ok" ||
              data.data.status === "underwriter" ||
              data.data.status === "loan_officer" ||
              data.data.status === "loan" ||
              data.data.status === "underwriter_ok" ||
              data.data.status === "problem" ||
              data.data.status === "insurance" ||
              data.data.status === "underwriter_nok"
            ) {
              state = "approve";
            } else if (data.data.status === "pre_scoring_nok") {
              state = "reject";
            } else if (data.data.status === "completed") {
              state = "done";
            } else if (data.data.status === "cancelled") {
              state = "cancel";
            }

            this.$emit("input", {
              status: JSON.stringify(response.data),
              state: state,
            });
          } else if (!data.success) {
            alert("Неизвестная ошибка");
            this.$loading(false);
          }
          //отправка нового статуса

          return response.data;
        })
        .catch((error) => {
          this.$loading(false);
          return errorNotify(error, this.notify);
        })
        .finally(() => {});
    },
    async cancelRequest() {
      this.$loading(true);

      const action = `applications/${this.data.exchange_id}/cancel`;
      const url = this.data.bank.api_endpoint_url + action;
      const token = this.data.bank.api_token;
      const auth_type = this.data.bank.api_auth_type;
      const method = "patch";
      // const data = this.data.form_data;

      logger(this.$http, {
        name: "Отмена заявки - запрос в банк",
        url: url,
        method: method,
      });

      return this.$http({
        method: method,
        // data: toFormData(data),
        url: url,
        headers: {
          // "Content-Type": `multipart/form-data`,
          Authorization: `${auth_type} ${token}`,
          "api-version": `1`,
          platform: `web`,
          language: `ru`,
          Accept: `application/json`,
        },
      })
        .then((response) => {
          const data = response.data;
          if (data && data.data && data.success === true) {
            let state = "sent";
            if (data.data.status === "cancelled") {
              state = "cancel";
            }
            this.$emit("input", {
              status: JSON.stringify(response.data),
              state: state,
            });
          } else if (!data.success) {
            alert("Неизвестная ошибка");
            this.$loading(false);
          }

          return response.data;
        })
        .catch((error) => {
          this.$loading(false);
          return errorNotify(error, this.notify);
        })
        .finally(() => {});
    },
  },
  data: () => ({}),
  props: ["value", "data"],
};
</script>
<style>
</style>
 